<template>
  <c-m-sidebar title="ADT History">
    <template #content>
      <div class="adt-history">
        <template v-if="loading">
          <div class="adt-history__loading">Loading ADT history...</div>
        </template>
        <template v-else-if="adtHistory">
          <template v-if="adtHistory.length">
            <div class="adt-history__item" :key="item.id" v-for="item in adtHistory">
              <div class="adt-history__header">
                <div class="adt-history__header-top">
                  <span class="adt-history__adt-event">
                    {{ item.adt_event }} - {{ getAdtEventLabel(item.adt_event) }}
                  </span>
                  <span class="adt-history__date">{{ $helpers.formatDate(item.created_at, 'LLL') }}</span>
                </div>
              </div>

              <div class="adt-history__changes">
                <div v-if="item.patient_change" class="adt-history__change">
                  <span class="adt-history__change-label">Patient:</span>
                  <span class="adt-history__change-value">{{ item.patient_change }}</span>
                </div>

                <div class="adt-history__change">
                  <span class="adt-history__change-label">Monitor:</span>
                  <span class="adt-history__change-value">{{ item.monitoring_change || '-' }}</span>
                </div>

                <div v-if="item.details && Object.keys(item.details).length > 0" class="adt-history__details">
                  <div class="adt-history__details-label">Updated</div>
                  <div class="adt-history__details-content">
                    <div v-for="(value, key) in item.details" :key="key" class="adt-history__detail-item">
                      <span>{{ key }}: {{ value }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <div class="adt-history__empty" v-else>No ADT history found for this patient</div>
        </template>
      </div>
    </template>
  </c-m-sidebar>
</template>

<script>
import CMSidebar from "@/components/safety_center/CMSidebar.vue";
import to from "@/lib/to";

export default {
  name: "ADTHistorySidebar",
  components: {CMSidebar},
  props: ['patientId'],
  async mounted() {
    this.loading = true
    const [err, response] = await to(this.$http.get(`/patients/${this.patientId}/adt_history`))
    if (!err) {
      this.adtHistory = response.data
    }
    this.loading = false
  },
  methods: {
    getAdtEventLabel(eventCode) {
      return this.adtEventLabels[eventCode] || 'Unknown Event'
    }
  },
  data() {
    return {
      adtHistory: null,
      loading: false,
      adtEventLabels: {
        'A01': 'Admit',
        'A02': 'Transfer',
        'A03': 'Discharge',
        'A06': 'Outpatient to Inpatient',
        'A07': 'Inpatient to Outpatient',
        'A08': 'Update Demographics',
        'A11': 'Cancel Admit',
        'A12': 'Cancel Transfer',
        'A13': 'Cancel Discharge',
        'A18': 'Merge Patient Info',
        'A34': 'Merge Patient ID',
        'A45': 'Move Visit'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.adt-history {
  &__loading {
    text-align: center;
    padding: 20px;
    color: #666;
  }

  &__empty {
    text-align: center;
    padding: 20px;
    color: #999;
  }

  &__item {
    background: #fff;
    padding: 15px;
    border-radius: 8px;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  &__header {
    margin-bottom: 12px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;
  }

  &__header-top {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  &__adt-event {
    font-size: 13px;
    font-weight: 600;
    color: #2563eb;
    background-color: #eff6ff;
    padding: 4px 8px;
    border-radius: 4px;
    border-left: 3px solid #2563eb;
  }

  &__date {
    font-size: 11px;
    color: #666;
    font-weight: 500;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &__changes {
    font-size: 14px;
  }

  &__change {
    margin-bottom: 8px;
    display: flex;
    align-items: flex-start;
    gap: 8px;
  }

  &__change-label {
    font-weight: 600;
    color: #333;
    min-width: 80px;
  }

  &__change-value {
    color: #555;
    flex: 1;
  }

  &__details {
    margin-top: 12px;
    padding-top: 10px;
    border-top: 1px solid #f5f5f5;
  }

  &__details-label {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  &__details-content {
    padding-left: 10px;
  }

  &__detail-item {
    font-size: 12px;
    color: #777;
    margin-bottom: 4px;

    span {
      display: inline-block;
    }
  }
}
</style>